<template>
  <div class="min-vh-100 bg-light d-flex flex-column align-items-center justify-content-center p-3">
    <div class="card shadow-sm border-0 w-100" style="max-width: 900px;">
      <div class="card-body">
        <h5 class="fw-bold text-center mb-3">Transport Voucher</h5>
        <!-- Hidden Voucher Canvas -->
        <canvas
          ref="voucherCanvas"
          style="display:none"
        ></canvas>

        <!-- BASIC INFO -->
        <div class="row g-2 small mb-3">
          <div class="col-md-4"><label>Vessel</label><input v-model="form.vessel" class="form-control form-control-sm"/></div>
          <div class="col-md-4" style="display:none"><label>PIC</label><input v-model="form.pic" class="form-control form-control-sm"/></div>
          <div class="col-md-4"><label>Driver</label><input v-model="form.driver" class="form-control form-control-sm"/></div>

          <div class="col-md-3"><label>Date</label><input v-model="form.date" type="date" class="form-control form-control-sm"/></div>
          <div class="col-md-3">
            <label>Start Time</label>
            <input
              v-model="form.timeStart"
              type="text"
              placeholder="HH:mm"
              class="form-control form-control-sm"
            />
          </div>

          <div class="col-md-3">
            <label>End Time</label>
            <input
              v-model="form.timeEnd"
              type="text"
              placeholder="HH:mm"
              class="form-control form-control-sm"
            />
          </div>
          <div class="col-md-3"><label>Vehicle No</label><input v-model="form.vehicleNo" class="form-control form-control-sm"/></div>

          <div class="col-md-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm"/></div>
          <div class="col-md-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm"/></div>

          <div class="col-md-4"><label>Rank</label><input v-model="form.rank" class="form-control form-control-sm"/></div>
          <div class="col-md-4"><label>Crew</label><input v-model="form.crew" class="form-control form-control-sm"/></div>
          <div class="col-md-4"><label>Pax</label><input v-model="form.pax" class="form-control form-control-sm"/></div>

          <div class="col-md-12"><label>Flight</label><input v-model="form.flight" class="form-control form-control-sm"/></div>
          <div class="col-md-12"><label>Remarks</label><input v-model="form.remarks" class="form-control form-control-sm"/></div>
        </div>

        <!-- SERVICES -->
        <hr/>
        <h6 class="fw-bold">Services</h6>

        <div class="row g-2 small">
          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.crewTransportation" class="form-check-input">
            <label class="form-check-label">Crew Transportation</label>
            <!-- <input
                v-if="form.crewTransportation"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.crewTransportation.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.deliveryCollection" class="form-check-input">
            <label class="form-check-label">Delivery / Collection</label>
            <!-- <input
                v-if="form.deliveryCollection"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.deliveryCollection.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.erp" class="form-check-input">
            <label class="form-check-label">ERP</label>
            <!-- <input
                v-if="form.erp"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.erp.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.waitingHrs" class="form-check-input">
            <label class="form-check-label">Waiting Hrs</label>
            <!-- <input
                v-if="form.waitingHrs"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.waitingHrs.amount" -->
              <!-- /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.meals" class="form-check-input">
            <label class="form-check-label">Meals</label>
            <!-- <input
                v-if="form.meals"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.meals.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.additionalStop" class="form-check-input">
            <label class="form-check-label">Additional Stop</label>
            <!-- <input
                v-if="form.additionalStop"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.additionalStop.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.parking" class="form-check-input">
            <label class="form-check-label">Parking</label>
            <!-- <input
                v-if="form.parking"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.parking.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.oddSurcharge" class="form-check-input">
            <label class="form-check-label">Odd Hrs</label>
            <!-- <input
                v-if="form.oddSurcharge"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.oddSurcharge.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.meeting" class="form-check-input">
            <label class="form-check-label">Meeting</label>
            <!-- <input
                v-if="form.meeting"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.meeting.amount"
              /> -->
          </div>

          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.disposal" class="form-check-input">
            <label class="form-check-label">Disposal</label>
            <!-- <input
                v-if="form.disposal"
                type="number"
                class="form-control form-control-sm mt-1"
                placeholder="Amount"
                v-model.number="serviceFlags.disposal.amount"
              /> -->
          </div>
          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.arrival" class="form-check-input">
            <label class="form-check-label">Arrival</label>
          </div>
          <div class="col-md-3 form-check">
            <input type="checkbox" v-model="form.departure" class="form-check-input">
            <label class="form-check-label">Departure</label>
          </div>
        </div>

        <div class="mt-2" v-if="form.waitingHrs">
          <label>Waiting Hrs Info</label>
          <input v-model="form.waitingHrsInfo" class="form-control form-control-sm"/>
        </div>

        <div class="mt-2" v-if="form.additionalStop">
          <label>Additional Stop Info</label>
          <input v-model="form.additionalStopInfo" class="form-control form-control-sm"/>
          
        </div>

        <div class="mt-2" v-if="form.disposal">
          <label>Disposal Info</label>
          <input v-model="form.disposalInfo" class="form-control form-control-sm"/>
        </div>

        <!-- SIGNATURE -->
        <div class="mt-4">
          <label>Signature</label>
          <canvas ref="signaturePad" class="border rounded w-100" style="height:120px"
            @mousedown="startSign"
            @mousemove="drawSign"
            @mouseup="endSign"
            @mouseleave="endSign"
            @touchstart.prevent="startSign"
            @touchmove.prevent="drawSign"
            @touchend.prevent="endSign"
          ></canvas>

          <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">
            Clear Signature
          </button>
        </div>

        <div class="text-center mt-4">
          <button class="btn btn-primary" @click="saveVoucher" :disabled="isUploading">
            Save Voucher
          </button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import router from '@/router'
import { useToast } from 'vue-toastification'

export default {
  name: 'TransportVoucher',

  data() {
    return {
      voucherBg: require('@/assets/transportVoucher.png'),
      jobId: '',
      token: '',
      role: '',
      isUploading: false,
      drawing: false,
      ctx: null,
      
      serviceFlags:{
        crewTransportation:{ label:"Crew Transportation ", amount:0 },
        deliveryCollection:{ label:"Delivery/Collection ", amount:0 },
        erp:{ label:"ERP ", amount:0 },
        waitingHrs:{ label:"Waiting Hrs ", amount:0 },
        meals:{ label:"Meals ", amount:0 },
        additionalStop:{ label:"Additional Stop ", amount:0 },
        parking:{ label:"Parking ", amount:0 },
        oddSurcharge:{ label:"Odd Hrs ", amount:0 },
        meeting:{ label:"Meeting ", amount:0 },
        disposal:{ label:"Disposal ", amount:0 }
      },
      form: {
        voucherId:"",
        vessel: '',
        pic: '',
        driver: '',
        vehicleNo: '',

        date: '',
        timeStart: '',
        timeEnd: '',

        from: '',
        to: '',
        rank: '',
        crew: '',
        pax: '',
        flight: '',
        remarks: '',

        // services
        crewTransportation: false,
        deliveryCollection: false,
        erp: false,
        waitingHrs: false,
        meals: false,
        additionalStop: false,
        parking: false,
        oddSurcharge: false,
        meeting: false,
        disposal: false,
        departure:"",
        arrival:"",

        waitingHrsInfo: '',
        additionalStopInfo: '',
        disposalInfo: ''
      }
    }
  },

  setup() {
    return { toast: useToast() }
  },

  async mounted() {
    this.jobId = this.$route.params.jobId
    this.token = this.$route.params.token
    
    if (!this.token) {
      this.toast.error("Missing access token")
      return
    }

    const ok = await this.verifyAccessToken(this.token)
    if (!ok) {
      this.toast.error("Invalid or expired token")
      return
    }

    await this.fetchVoucherData()
    this.form.voucherId = "VCHR-" + crypto.randomUUID().replace(/-/g, "").slice(0, 8).toUpperCase()

    this.initSignaturePad()
  },
  //  watch:{
  //     serviceFlags:{
  //       handler(){
  //         this.updateServiceRemarks()
  //       },
  //       deep:true
  //     },
  //     form:{
  //       handler(){
  //         this.updateServiceRemarks()
  //       },
  //       deep:true
  //     }
  //   } ,

  methods: {

    // ================= TOKEN VERIFY =================
    async verifyAccessToken(token) {
      try {
        const res = await axios.get(
          `${this.$apiURL}/api/token/verify`,
          { params: { token } }
        )

        if (res.data?.ok) {
          this.role = res.data.role || 'driver'

          if (res.data.bookingId !== this.jobId) {
            console.warn("Token booking mismatch")
            return false
          }

          return true
        }

      } catch (err) {
        console.error("verifyAccessToken error:", err)
      }

      return false
    },

    async getAuthHeader() {
      return { Authorization: this.token }
    },

    // ================= FETCH BOOKING =================
    async fetchVoucherData() {
      const headers = await this.getAuthHeader()

      const res = await axios.get(
        `${this.$apiURL}/api/bookings/${this.jobId}/voucher-data`,
        { headers }
      )

      Object.assign(this.form, res.data)
      const data = res.data
      // 🔥 V2 Crew Handling
      if (!data.crew && Array.isArray(data.crewMembers) && data.crewMembers.length > 0) {
        this.form.crew = data.crewMembers[0]?.name || ''
        this.form.rank = data.crewMembers[0]?.rank || '' 

      }
    },

    // ================= SIGNATURE =================
    initSignaturePad() {
      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()

      c.width = rect.width
      c.height = rect.height
    },

    startSign(e) {
      const c = this.$refs.signaturePad
      this.ctx = c.getContext('2d')
      this.ctx.strokeStyle = '#000'
      this.ctx.lineWidth = 2

      const rect = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e

      this.ctx.beginPath()
      this.ctx.moveTo(
        p.clientX - rect.left,
        p.clientY - rect.top
      )

      this.drawing = true
    },

    drawSign(e) {
      if (!this.drawing) return

      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e

      this.ctx.lineTo(
        p.clientX - rect.left,
        p.clientY - rect.top
      )

      this.ctx.stroke()
    },

    endSign() {
      this.drawing = false
    },

    clearSign() {
      const c = this.$refs.signaturePad
      c.getContext('2d').clearRect(0, 0, c.width, c.height)
    },
    updateServiceRemarks(){

      const lines = []

      Object.keys(this.serviceFlags).forEach(k => {

        if (this.form[k]) {

          const svc = this.serviceFlags[k]
          const amount = svc.amount

          if (amount && amount > 0) {
            lines.push(`${svc.label}SGD$${amount}`)
          }

        }

      })

      // join nicely
      this.form.remarks = lines.join(' | ')

    },
    // ================= SAVE =================
    async saveVoucher() {

      if (!this.jobId) {
        this.toast.error("Missing Job ID")
        return
      }

      this.isUploading = true

      try {

        const headers = await this.getAuthHeader()
        const formData = new FormData()

        // 🔥 1️⃣ DRAW HIDDEN VOUCHER FIRST
        // await this.drawVoucher()
        // ================================
        // 1️⃣ GENERATE SEQUENTIAL NUMBER
        // ================================
        const res = await axios.post(
          `${this.$apiURL}/api/voucher/generate-number`,
          {},
          { headers }
        );

        if (!res.data?.success) {
          throw new Error("Failed to generate voucher number");
        }

        const voucherNumber = res.data.voucherNumber;

        // set voucher id
        this.form.voucherId = voucherNumber;

        // ================================
        // 2️⃣ REDRAW VOUCHER WITH NUMBER
        // ================================
        await this.drawVoucher()

        const voucherCanvas = this.$refs.voucherCanvas

        const voucherBlob = await new Promise(resolve =>
          voucherCanvas.toBlob(resolve, "image/png")
        )

        if (!voucherBlob) {
          throw new Error("Voucher image generation failed")
        }

        formData.append(
          "voucherFile",
          voucherBlob,
          `TransportVoucher_${this.jobId}.png`
        )

        // 🔥 2️⃣ ATTACH SIGNATURE
        const signCanvas = this.$refs.signaturePad

        const sigBlob = await new Promise(resolve =>
          signCanvas.toBlob(resolve, "image/png")
        )

        if (sigBlob) {
          formData.append(
            "signature",
            sigBlob,
            `Signature_${this.jobId}.png`
          )
        }

        // 🔥 3️⃣ BUILD PAYLOAD
        const payload = {
          voucherId : this.form.voucherId,
          vesselName: this.form.vessel,
          engagedBy: this.form.pic,
          driverName: this.form.driver,
          vehicleNo: this.form.vehicleNo,

          date: this.form.date,
          timeStart: this.form.timeStart,
          timeEnd: this.form.timeEnd,

          from: this.form.from,
          to: this.form.to,
          paxName: this.form.crew,
          rank: this.form.rank,
          paxs: this.form.pax,
          flightNo: this.form.flight,
          remarks: this.form.remarks,

          crewTransportation: this.form.crewTransportation,
          delivery: this.form.deliveryCollection,
          erp: this.form.erp,
          waitingHrs: this.form.waitingHrs,
          waitingHrsInfo: this.form.waitingHrsInfo,
          mealsForCrew: this.form.meals,
          additionalStop: this.form.additionalStop,
          additionalStopInfo: this.form.additionalStopInfo,
          parkingFees: this.form.parking,
          oddHrsSurcharge: this.form.oddSurcharge,
          meetingServices: this.form.meeting,
          disposal: this.form.disposal,
          disposalInfo: this.form.disposalInfo,
          arrival: this.form.arrival || '',
          departure: this.form.departure || '',
        }

        formData.append("data", JSON.stringify(payload))

        // 🔥 4️⃣ SEND TO BACKEND
        const res2 = await axios.post(
          `${this.$apiURL}/api/bookings/${this.jobId}/vouchers/token`,
          formData,
          { headers }
        )

        if (res2.data?.ok) {
          this.toast.success("Voucher saved")
          router.push(`/success/${this.jobId}/${this.token}`)
        } else {
          this.toast.error(res2.data?.error || "Save failed")
        }

      } catch (err) {
        console.error("saveVoucher error:", err)
        this.toast.error("Error saving voucher")
      } finally {
        this.isUploading = false
      }
    },
  // ================= CANVAS =================
    drawVoucher() {
      return new Promise((resolve, reject) => {
      const canvas = this.$refs.voucherCanvas
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.voucherBg

      img.onload = () => {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)

        ctx.fillStyle = '#000'
        ctx.font = '26px Arial'

        // ctx.font = '35px Arial' 
        ctx.fillStyle = 'red' 
        ctx.fillText(this.form.voucherId, 1570, 75) 
        ctx.fillStyle = 'black' 
        ctx.fillText(this.form.pax, 650, 300) 
        ctx.fillText(this.form.vessel, 430, 450) 
        ctx.fillText(this.form.date, 1450, 140) 
        ctx.fillText(this.form.flight, 1640, 240) 
        ctx.fillText(this.form.rank, 1300, 380) 
        ctx.fillText(this.form.crew, 430, 380) 
        ctx.fillText(this.form.from, 430, 520) 
        ctx.fillText(this.form.to, 1300, 520) 
        ctx.fillText(this.form.vehicleNo, 400, 1020) 
        ctx.fillText(this.form.pic, 1300, 450) 
        ctx.fillText(this.form.driver, 720, 1020) 
        // ctx.fillText(this.form.time, 560, 230) 
        // ctx.fillText(this.form.crew, 270, 350) 
        // ctx.fillText(this.form.remarks, 400, 1120) 
        ctx.font = '20px Arial'

        const remarks = this.form.remarks || ""
        const maxWidth = ctx.measureText("WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW").width
        const lineHeight = 83

        let y = 1120
        let line = ""
        let lineCount = 0

        for (let i = 0; i < remarks.length; i++) {

          // if already on line 3 → no more wrapping
          if (lineCount === 2) {
            line += remarks.slice(i)
            break
          }

          const testLine = line + remarks[i]
          const width = ctx.measureText(testLine).width

          if (width > maxWidth && line !== "") {

            ctx.fillText(line, 360, y)

            line = remarks[i]
            y += lineHeight
            lineCount++

          } else {
            line = testLine
          }

        }

        ctx.fillText(line, 360, y)

        ctx.font = '26px Arial'
        ctx.fillText(this.form.timeStart, 430, 590)
        ctx.fillText(this.form.timeEnd, 1300, 590)
        // Services ✔
        // ===== Services (hard-coded positions) =====
        // ctx.font = '26px Arial'
        ctx.fillStyle = '#000'
        ctx.font = '45px Arial'

        // Crew Transportation
        if (this.form.crewTransportation) {
          ctx.fillText('✔', 385, 300)
        }

        // Delivery / Collection
        if (this.form.deliveryCollection) {
          ctx.fillText('✔', 900, 300)
        }
        // ERP
        if (this.form.erp) {
          ctx.fillText('✔', 210, 765)
        }
  
        if (this.form.arrival) {

          const x = 1340
          const y = 240
          const radius = 40

          // draw circle
          ctx.beginPath()
          ctx.arc(x, y, radius, 0, Math.PI * 2)
          ctx.stroke()   // border
          // ctx.fill()  // if you want filled circle

          // text settings
          ctx.textAlign = "center"
          ctx.textBaseline = "middle"

          // draw text in center
          ctx.fillText(this.form.arrival, x, y)
        }

        // Waiting Hours
        if (this.form.waitingHrs) {
          ctx.fillText('✔', 470, 760)
          if (this.form.waitingHrsInfo) {
            ctx.font = '26px Arial'
            const text = this.form.waitingHrsInfo

            if (text.length <= 15) {
              ctx.fillText(text, 675, 760)
            } else {
              const line1 = text.slice(0, 15)
              const line2 = text.slice(15)

              ctx.fillText(line1, 675, 760)
              ctx.fillText(line2, 675, 785) // move down a bit
            }
            ctx.font = '45px Arial'
          }
        }

        // Meals for Crew
        if (this.form.meals) {
          ctx.fillText('✔', 875, 760)
        }

        // Additional Stop
        if (this.form.additionalStop) {
          ctx.fillText('✔', 1165, 760)
          if (this.form.additionalStopInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.additionalStopInfo, 1400, 755)
            ctx.font = '45px Arial'
          }
        }

        // Parking Fee
        if (this.form.parking) {
          ctx.fillText('✔', 210, 870)
        }

        // Odd Hours Surcharge
        if (this.form.oddSurcharge) {
          ctx.fillText('✔', 470, 870)
        }

        // Meeting Services
        if (this.form.meeting) {
          ctx.fillText('✔', 875, 865)
        }

        // Disposal
        if (this.form.disposal) {
          ctx.fillText('✔', 1167, 875)
          if (this.form.disposalInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.disposalInfo, 1365, 855)
            ctx.font = '45px Arial'

          }
        }



        // if (this.form.additionalStopInfo)
        //   ctx.fillText(this.form.additionalStopInfo, 180, 720)

        // if (this.form.disposalInfo)
        //   ctx.fillText(this.form.disposalInfo, 180,720)

        // Signature
        const sig = this.$refs.signaturePad
        ctx.drawImage(sig, 1300, 1000, 250, 250)
          resolve()   // 🔥 VERY IMPORTANT
      }

      img.onerror = reject
    })
    },
  }

}
</script>
